import { observable } from "mobx";
import Api from "../service/Api";
import LoadScript from "../utils/LoadScript";

class Immersive3dTourPlayer {
  @observable
  script = null;

  load() {
    return new Promise((resolve, reject) => {
      const internalLoad = script => {
        LoadScript("immersive-3d-tour-player-js", script, "anonymous").then(() => {
          resolve();
        }, reject);
      };

      // Get the script we need to load for this player
      Api.get("/immersive-3d-tour-configurations").then(response => {
        this.script = response.data.player;

        internalLoad(this.script);
      }, reject);
    });
  }
}

export default Immersive3dTourPlayer;
